import React, { ReactElement } from 'react';
import style from './style.module.scss';
import classNames from 'classnames';
import { IProps } from './types';
import PaymentMessageContainer from 'internal-components/PaymentMessage/container';
import PaymentCardLogos from 'shared-components/payment-card-logos/index';
import { renderIf } from 'shared-services/react-utils-service/index';
import { Paper, Typography, Divider, Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import { paymentProviderType, IEwayInfo, themeTypes } from 'shared-types/WidgetTypes';
import { IntlService } from 'shared-services/intl-service/index';
import MenuOptionSummary from 'shared-components/menu-option-summary/index';
import { lookType } from 'shared-components/menu-option-summary/types';
import AlertPanel from 'shared-components/alert-panel/index';

const NS = 'PaymentSummary';

export default function PaymentSummary({
  theme,
  wrapperStyle,
  venuePaymentProvider,
  venuePaymentSettings,
  menuOptions,
  email,
  currency,
  payment,
  warningMessage
}: IProps) {

  const isDark = theme.type === themeTypes.dark || theme.type === themeTypes.outlinedDark;

  const Price = ({val, isColored}: {val: number, isColored: boolean}): ReactElement => {
    return (
      <span className={isColored ? "secondary-text" : ''}>
        {IntlService.currencyValue(val, currency)}
      </span>
    )
  }
  
  return (
    <Paper className={style.root}>

      <Typography variant="h2" className={style.heading}>
        Payment
      </Typography>

      <Divider className={style.divider} />

      <div className={style.paymentMessage}>
        <PaymentMessageContainer />
      </div>


      <div className={classNames({
        [style.tableWrap]: true,
        [style.tableWrapIsDark]: isDark
      })}>
        {/* needs separate table because the email determines the width of the columns */}
        {renderIf(email, (
          <Table aria-label="customer details" size="medium" >
            <TableBody>
              <TableRow>
                <TableCell>Email:</TableCell>
                <TableCell align="right">{email}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ))}

      {renderIf(payment, () => (

        <Table aria-label="summary" size="medium" >
          <TableBody>
            {renderIf(menuOptions, () => (
              <MenuOptionSummary theme={theme} currency={currency} menuOptions={menuOptions} look={lookType.paymentSummary} />
            ))}

            {renderIf(payment.discountAmount, (
              <TableRow>
                <TableCell>Required Payment ({currency}):</TableCell>
                <TableCell align="right">
                  <Price val={payment.price} isColored={true} />
                </TableCell>
              </TableRow>
            ))}
            {renderIf(payment.discountAmount, (
              <TableRow>
                <TableCell>Discount Amount ({currency}):</TableCell>
                <TableCell align="right">
                  <Price val={payment.discountAmount} isColored={true} />
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell>Total Amount ({currency}):</TableCell>
              <TableCell align="right">
                <Price val={payment.amountDue} isColored={true} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      ), () => (
          <Typography >
              No payment info
          </Typography>
      ))}
      </div>

      {renderIf(warningMessage, () => (
        <div className={style.alert}>
          <AlertPanel 
            wrapperStyle={wrapperStyle} 
            message={warningMessage}
            severity="warning"
            />
        </div>
      ))}

      {renderIf(venuePaymentProvider === paymentProviderType.eway, (
        <div className={style.cardLogos}>
          <PaymentCardLogos
            {...venuePaymentSettings as IEwayInfo}
            />
        </div>
      ))}
    </Paper>
  )
}